import {
  START_GET_ACTIVITY_LOG,
  SUCCESS_GET_ACTIVITY_LOG,
  ERROR_GET_ACTIVITY_LOG,
  START_GET_FIELD_STAFF_LIST,
  SUCCESS_GET_FIELD_STAFF_LIST,
  ERROR_GET_FIELD_STAFF_LIST,
  RESET_ACTIVITY_STATE,
} from "Actions/ActivityAction";

const initialState = {
  activityList: {
    loading: true,
    data: {},
    error: {},
  },
  staffFieldList: {
    loading: true,
    data: {},
    error: {},
  },
};

export const ActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_GET_ACTIVITY_LOG: {
      let oldList = state?.activityList?.data;
      return {
        ...state,
        activityList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case RESET_ACTIVITY_STATE: {
      console.log("reset activity state");

      return {
        ...state,
        activityList: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_ACTIVITY_LOG: {
      let oldList = state?.activityList?.data;
      console.log(oldList, "oldList");

      if (oldList?.list?.length > 0) {
        oldList.list =
          action?.loadmore == true
            ? [...oldList?.list, ...action?.payload?.data?.list]
            : action?.payload?.data?.list;
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        activityList: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_ACTIVITY_LOG: {
      return {
        ...state,
        activityList: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_GET_FIELD_STAFF_LIST: {
      let oldList = state?.staffFieldList?.data;
      return {
        ...state,
        staffFieldList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_FIELD_STAFF_LIST: {
      let oldList = state?.staffFieldList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        staffFieldList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_FIELD_STAFF_LIST: {
      return {
        ...state,
        staffFieldList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
